import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { Tooltip } from 'reactstrap';
import useStore from './../store';
import { CoreButton } from './../../../core';
import TwitterShareBtn from './TwitterShareBtn';
import { FacebookShareBtn } from '.';
import { MailShareBtn } from '.';
import { LinkShareBtn } from '.';

var DesktopUnifiedShareBtn = function DesktopUnifiedShareBtn(_ref) {
  var props = _extends({}, _ref); // to manage tooltip state


  var _useState = useState(false),
      tooltipOpen = _useState[0],
      setTooltipOpen = _useState[1];

  var toggle = function toggle() {
    return setTooltipOpen(!tooltipOpen);
  };

  return /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_d_u_share_link",
    label: i18n.translate("BUTTON_SHARE_UNIFIED"),
    color: "none",
    className: clsx(props.className, 'button-d-u-share-link')
  }, i18n.translate('CONTROL_PANEL_SHARE_TC'), /*#__PURE__*/React.createElement(Tooltip, {
    placement: "right",
    isOpen: tooltipOpen,
    target: "button_d_u_share_link",
    toggle: toggle,
    autohide: false,
    trigger: "hover",
    className: "tooltip-custom-share"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-custom-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement(TwitterShareBtn, {
    tooltip: false
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-label"
  }, i18n.translate("BUTTON_SHARE_TWITTER")))), /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement(FacebookShareBtn, {
    tooltip: false
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-label"
  }, i18n.translate("BUTTON_SHARE_FACEBOOK")))), /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement(MailShareBtn, {
    tooltip: false
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-label"
  }, i18n.translate("BUTTON_SHARE_EMAIL")))), /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement(LinkShareBtn, {
    tooltip: false
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-label"
  }, i18n.translate("BUTTON_SHARE_LINK")))))));
};

export default DesktopUnifiedShareBtn;